<div class="flex flex-col gap-8 py-4">
  <!-- Quand souhaitez-vous vendre votre logement ? -->
  <div class="flex flex-col gap-3">
    <span class="text-sm font-medium text-neutral-11"> Quand souhaitez-vous vendre votre logement ? </span>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Urgence de la vente</mat-label>
      <mat-select [formField]="formTree.saleUrgency">
        <mat-option [value]="PropertySaleUrgency.AS_SOON_AS_POSSIBLE">Au plus vite</mat-option>
        <mat-option [value]="PropertySaleUrgency.ONE_TO_THREE_MONTHS">Dans 1 à 3 mois</mat-option>
        <mat-option [value]="PropertySaleUrgency.THREE_TO_SIX_MONTHS">Dans 3 à 6 mois</mat-option>
        <mat-option [value]="PropertySaleUrgency.MORE_THAN_SIX_MONTHS">Dans plus de 6 mois</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Votre logement est-il déjà en vente ? -->
  <div class="flex flex-col gap-3">
    <span class="text-sm font-medium text-neutral-11">
      Votre logement est-il déjà en vente ? <span class="text-error-9 ml-0.5">*</span>
    </span>
    <mat-button-toggle-group
      aria-label="Logement déjà en vente"
      class="w-1/3"
      [formField]="formTree.isAlreadyOnSale"
    >
      <mat-button-toggle class="w-1/2" [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle class="w-1/2" [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
    @if (formTree.isAlreadyOnSale().errors().length) {
      <span class="text-[10px] text-red-11 font-medium animate-in fade-in slide-in-from-top-1">
        Veuillez indiquer si votre bien est déjà en vente
      </span>
    }
  </div>

  <!-- Conditional: Marketing Mode (Current) -->
  @if (model().isAlreadyOnSale === true) {
    <div class="flex flex-col gap-3 animate-in fade-in duration-300 slide-in-from-top-2">
      <span class="text-sm font-medium text-neutral-11">
        Quel mode de commercialisation avez-vous choisi ? <span class="text-error-9 ml-0.5">*</span>
      </span>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Mode de commercialisation choisi</mat-label>
        <mat-select [formField]="formTree.currentMarketingMode">
          <mat-option [value]="PropertyCurrentMarketingMode.AGENCY_SIMPLE"
            >Mandat simple en agence</mat-option
          >
          <mat-option [value]="PropertyCurrentMarketingMode.AGENCY_EXCLUSIVE"
            >Mandat exclusif en agence</mat-option
          >
          <mat-option [value]="PropertyCurrentMarketingMode.PAP">Entre particuliers (PAP)</mat-option>
          <mat-option [value]="PropertyCurrentMarketingMode.AGENCY_AND_PAP"
            >Mandat simple en agence et PAP</mat-option
          >
        </mat-select>
        @if (formTree.currentMarketingMode().errors().length) {
          <mat-error>Le mode de commercialisation est requis</mat-error>
        }
      </mat-form-field>

      <!-- Warning & Date for Exclusive Mandate -->
      @if (model().currentMarketingMode === PropertyCurrentMarketingMode.AGENCY_EXCLUSIVE) {
        <div
          class="flex flex-col gap-4 p-4 rounded-xl bg-amber-a2 border border-amber-a4 animate-in fade-in duration-300"
        >
          <div class="flex items-start gap-3">
            <mat-icon class="text-amber-9 shrink-0 mt-0.5">info</mat-icon>
            <div class="flex flex-col gap-1 text-sm">
              <span class="font-semibold text-amber-11">Mandat exclusif en cours</span>
              <p class="text-xs text-neutral-11 leading-relaxed">
                Un mandat exclusif vous engage juridiquement auprès de votre agence actuelle jusqu'à son terme
                (ou sa résiliation avec préavis). Vous pouvez tout de même préparer dès aujourd'hui la mise en
                concurrence des agents ETXE pour la date de fin de votre exclusivité.
              </p>
            </div>
          </div>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Date de fin d'exclusivité (ou de résiliation)</mat-label>
            <input
              matInput
              [matDatepicker]="exclusivePicker"
              [formField]="formTree.exclusiveMandateEndDate"
              [min]="minMandateEndDate"
            />
            <mat-datepicker-toggle matIconSuffix [for]="exclusivePicker"></mat-datepicker-toggle>
            <mat-datepicker #exclusivePicker></mat-datepicker>
            <mat-hint>Date à laquelle votre bien sera libéré d'engagement</mat-hint>
            @if (formTree.exclusiveMandateEndDate().errors().length) {
              <mat-error>La date de fin d'exclusivité est requise</mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
  }

  <!-- Occupation -->
  <div class="flex flex-col gap-3 pt-4 border-t border-neutral-4">
    <span class="text-sm font-medium text-neutral-11">
      Le bien est actuellement occupé <span class="text-error-9 ml-0.5">*</span>
    </span>
    <mat-button-toggle-group
      aria-label="Le bien est actuellement occupé"
      class="w-1/3"
      [formField]="formTree.isOccupied"
    >
      <mat-button-toggle class="w-1/2" [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle class="w-1/2" [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
    @if (formTree.isOccupied().errors().length) {
      <span class="text-[10px] text-red-11 font-medium animate-in fade-in slide-in-from-top-1">
        Veuillez indiquer si votre bien est actuellement occupé
      </span>
    }

    @if (model().isOccupied === true) {
      <div class="flex flex-col gap-3 animate-in fade-in duration-300 slide-in-from-top-2">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Occupé approximativement jusqu'au</mat-label>
          <input matInput [matDatepicker]="occPicker" [formField]="formTree.occupiedUntil" [min]="minDate" />
          <mat-datepicker-toggle matIconSuffix [for]="occPicker"></mat-datepicker-toggle>
          <mat-datepicker #occPicker></mat-datepicker>

          @if (formTree.occupiedUntil().errors().length) {
            <mat-error> La date est requise (au moins demain) </mat-error>
          }
        </mat-form-field>
      </div>
    }
  </div>
</div>
